import { useState } from 'react';

export function useContractEditing() {
  const [editingBlockId, setEditingBlockId] = useState(null);
  const [activeBlockData, setActiveBlockData] = useState(null);
  const [tempTitle, setTempTitle] = useState("");
  const [isModified, setIsModified] = useState(false);
  const [expandedInactiveId, setExpandedInactiveId] = useState(null);

  return {
    editingBlockId, setEditingBlockId,
    activeBlockData, setActiveBlockData,
    tempTitle, setTempTitle,
    isModified, setIsModified,
    expandedInactiveId, setExpandedInactiveId,
  };
}
